import { useSyncExternalStore } from 'react'
import { appShellPresence } from '@claritio/frontend/lib/appShellPresence'
import { publicReportPagePresence } from '@claritio/frontend/lib/publicReportPagePresence'
import LanguageToggle from './LanguageToggle'

// Renders the language switch on every page that ISN'T inside the AppShell
// (auth, employee, and public interview pages) — the admin chrome shows its own
// toggle in the header. Fixed top-right so it's always discoverable (ENG-111).
// Suppressed on PublicReport pages which render their own inline toggle (ENG-138).
export default function FloatingLanguageToggle() {
  const hasAppShell = useSyncExternalStore(
    appShellPresence.subscribe,
    appShellPresence.getSnapshot,
    () => false,
  )
  const isPublicReportPage = useSyncExternalStore(
    publicReportPagePresence.subscribe,
    publicReportPagePresence.getSnapshot,
    () => false,
  )
  if (hasAppShell || isPublicReportPage) return null
  return (
    <div className="fixed right-3 top-3 z-50 print:hidden">
      <LanguageToggle className="shadow-sm" />
    </div>
  )
}
